import { TabPane } from 'reactstrap';
import * as actionTypes from "../../store/Actions/actions";
import { useDispatch, useSelector } from 'react-redux';
import Default from "../../assets/images/default.jpg";
import HighlightActiveBorder from "../../assets/images/highlightActiveBorder.jpg";
import Underlined from "../../assets/images/underlined.jpg";
import BoxItem from "../../assets/images/boxItem.jpg";
import BoxNav from "../../assets/images/boxNav.jpg";

export const TabPresetStyles = () => {
    const { navClass } = useSelector(state => state.present);
    const dispatch = useDispatch();
    return (
        <TabPane tabId="4">
            <div
                style={{ paddingTop: "10px" }}
                className="col-sm-12 navigationSettings nav-showcase"
            >
                <div className="wrap">
                    <ul
                        onClick={() => {
                            dispatch(actionTypes.nav_class("default"))
                        }}
                        value="default"
                        className={
                            "default " +
                            (navClass == "default" ? "active" : " ")
                        }
                    >
                        <img src={Default} alt="Default" />
                    </ul>
                </div>
                <div className="wrap">
                    <ul
                        onClick={() => {
                            dispatch(actionTypes.nav_class("highlightActiveBorder"))
                        }}
                        value="highlightActiveBorder"
                        className={
                            "highlightActiveBorder " +
                            (navClass == "highlightActiveBorder"
                                ? "active"
                                : " ")
                        }
                    >
                        <img
                            src={HighlightActiveBorder}
                            alt="HighlightActiveBorder"
                        />
                    </ul>
                </div>
                <div className="wrap">
                    <ul
                        onClick={() => {
                            dispatch(actionTypes.nav_class("underlined"))
                        }}
                        value="underlined"
                        className={
                            "underlined " +
                            (navClass == "underlined"
                                ? "active"
                                : " ")
                        }
                    >
                        <img src={Underlined} alt="Underlined" />
                    </ul>
                </div>
                <div className="wrap">
                    <ul
                        onClick={() => {
                            dispatch(actionTypes.nav_class("boxItem"))
                        }}
                        value="boxItem"
                        className={
                            "boxItem " +
                            (navClass == "boxItem" ? "active" : " ")
                        }
                    >
                        <img src={BoxItem} alt="BoxItem" />
                    </ul>
                </div>
                <div className="wrap">
                    <ul
                        onClick={() => {
                            dispatch(actionTypes.nav_class("boxNav"))
                        }}
                        value="boxNav"
                        className={
                            "boxNav " +
                            (navClass == "boxNav" ? "active" : " ")
                        }
                    >
                        <img src={BoxNav} alt="BoxNav" />
                    </ul>
                </div>
            </div>
        </TabPane>
    )
}
